import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { SidebarItemOption } from "./SidebarItem";

interface SidebarProps extends SidebarItemOption {}

export const SidebarItemGroup = (menuItem: SidebarProps): JSX.Element => {
  const { title, path, icon } = menuItem;
  const { pathname } = useLocation();
  const isActive = pathname.includes(path);

  return (
    <NavLink end to={path}>
      <li
        className={`sidebar-expanded:block group relative mb-1 cursor-pointer rounded-lg px-3 py-3 transition-all duration-200 ease-in-out ${
          isActive
            ? "bg-primary-500/10 text-primary-600 dark:text-primary-400 border-l-3 border-primary-500 shadow-sm"
            : "text-slate-400 hover:bg-slate-700/50 hover:text-slate-600 dark:hover:bg-slate-700/30 dark:hover:text-slate-300"
        }`}
      >
        <div className="flex items-center">
          <div
            className={`flex-shrink-0 transition-colors duration-200 ${
              isActive
                ? "text-primary-600 dark:text-primary-400"
                : "text-slate-400 group-hover:text-slate-600 dark:group-hover:text-slate-300"
            }`}
          >
            {icon({ size: 20 })}
          </div>

          <span
            className={`sidebar-expanded:block lg:sidebar-expanded:opacity-100 ml-3 hidden max-lg:block text-sm font-medium transition-all duration-200 lg:opacity-0 2xl:opacity-100 ${
              isActive
                ? "text-primary-700 dark:text-primary-300 font-semibold"
                : "group-hover:text-slate-700 dark:group-hover:text-slate-200"
            }`}
          >
            {title}
          </span>

          {/* Active indicator dot - only visible when collapsed */}
          {isActive && (
            <div className="bg-primary-500 sidebar-expanded:hidden max-lg:hidden absolute right-2 h-2 w-2 rounded-full"></div>
          )}
        </div>

        {/* Subtle focus ring for accessibility */}
        <div className="group-focus-within:ring-primary-500/50 pointer-events-none absolute inset-0 rounded-lg ring-2 ring-transparent transition-all duration-200"></div>
      </li>
    </NavLink>
  );
};
